/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateAssetComponentRequestDto
 */
export interface UpdateAssetComponentRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetComponentRequestDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssetComponentRequestDto
     */
    serialNumber?: string | null;
    /**
     * Knowledge-base asset context (asset type → subsystem → component class → component type)
     * @type {string}
     * @memberof UpdateAssetComponentRequestDto
     */
    assetContextId?: string;
    /**
     * OCPP role discriminator: connector | controller
     * @type {string}
     * @memberof UpdateAssetComponentRequestDto
     */
    componentType?: UpdateAssetComponentRequestDtoComponentTypeEnum | null;
    /**
     * OCPP connector index (1, 2, 3, …)
     * @type {number}
     * @memberof UpdateAssetComponentRequestDto
     */
    connectorId?: number | null;
    /**
     * OCPP charge-box / controller identity
     * @type {string}
     * @memberof UpdateAssetComponentRequestDto
     */
    ocppId?: string | null;
    /**
     * FK to the controller ComponentSchema on the same asset (connectors belong to a controller)
     * @type {string}
     * @memberof UpdateAssetComponentRequestDto
     */
    controllerId?: string | null;
    /**
     * Changing assetId is blocked while the component is in a twins group
     * @type {string}
     * @memberof UpdateAssetComponentRequestDto
     */
    assetId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof UpdateAssetComponentRequestDto
     */
    installedAt?: Date | null;
    /**
     * Setting removedAt is blocked while the component is in a twins group
     * @type {Date}
     * @memberof UpdateAssetComponentRequestDto
     */
    removedAt?: Date | null;
    /**
     * Free-form component metadata (JSON object)
     * @type {{ [key: string]: any; }}
     * @memberof UpdateAssetComponentRequestDto
     */
    attributes?: { [key: string]: any; } | null;
}


/**
 * @export
 */
export const UpdateAssetComponentRequestDtoComponentTypeEnum = {
    Connector: 'connector',
    Controller: 'controller'
} as const;
export type UpdateAssetComponentRequestDtoComponentTypeEnum = typeof UpdateAssetComponentRequestDtoComponentTypeEnum[keyof typeof UpdateAssetComponentRequestDtoComponentTypeEnum];


/**
 * Check if a given object implements the UpdateAssetComponentRequestDto interface.
 */
export function instanceOfUpdateAssetComponentRequestDto(value: object): value is UpdateAssetComponentRequestDto {
    return true;
}

export function UpdateAssetComponentRequestDtoFromJSON(json: any): UpdateAssetComponentRequestDto {
    return UpdateAssetComponentRequestDtoFromJSONTyped(json, false);
}

export function UpdateAssetComponentRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAssetComponentRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
        'assetContextId': json['assetContextId'] == null ? undefined : json['assetContextId'],
        'componentType': json['componentType'] == null ? undefined : json['componentType'],
        'connectorId': json['connectorId'] == null ? undefined : json['connectorId'],
        'ocppId': json['ocppId'] == null ? undefined : json['ocppId'],
        'controllerId': json['controllerId'] == null ? undefined : json['controllerId'],
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
        'installedAt': json['installedAt'] == null ? undefined : (new Date(json['installedAt'])),
        'removedAt': json['removedAt'] == null ? undefined : (new Date(json['removedAt'])),
        'attributes': json['attributes'] == null ? undefined : json['attributes'],
    };
}

export function UpdateAssetComponentRequestDtoToJSON(json: any): UpdateAssetComponentRequestDto {
    return UpdateAssetComponentRequestDtoToJSONTyped(json, false);
}

export function UpdateAssetComponentRequestDtoToJSONTyped(value?: UpdateAssetComponentRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'serialNumber': value['serialNumber'],
        'assetContextId': value['assetContextId'],
        'componentType': value['componentType'],
        'connectorId': value['connectorId'],
        'ocppId': value['ocppId'],
        'controllerId': value['controllerId'],
        'assetId': value['assetId'],
        'installedAt': value['installedAt'] == null ? value['installedAt'] : value['installedAt'].toISOString(),
        'removedAt': value['removedAt'] == null ? value['removedAt'] : value['removedAt'].toISOString(),
        'attributes': value['attributes'],
    };
}

